import { useTheme } from 'styled-components';
import { DeviceConnectivityRow } from '../../../API/types/Devices';
import Tags from '../Tags';
import { ListItemWrapper } from '../../ui/ListItemWrapper/ListItemWrapper';
import { getFormattedDateAndTime } from '../../../utils/dateUtils';
import { IconKeys } from '../Icon/IconKeys';
import { ThemeType } from '../../../theme/themeType';

type Props = {
  item?: DeviceConnectivityRow;
};

function DeviceConnectivityItem({ item }: Readonly<Props>): JSX.Element {
  const theme = useTheme() as ThemeType;
  const { startDate, endDate, status } = item!;
  const isOnline = status?.toLowerCase() === 'online';
  const statusColor = isOnline ? theme.colors.green : theme.colors.red;

  return (
    <ListItemWrapper noclick alignLeft>
      <Tags.Status
        label={status || 'Unknown'}
        backgroundColor={statusColor}
      />
      <Tags.LabeledIcon
        flexible
        label={getFormattedDateAndTime(startDate, true)}
        icon={IconKeys.TIME}
      />
      {endDate && (
        <Tags.LabeledIcon
          flexible
          label={getFormattedDateAndTime(endDate, true)}
          icon={IconKeys.TIME}
        />
      )}
    </ListItemWrapper>
  );
}

export default DeviceConnectivityItem;
